import {DEV_COUNTER_MY_TRACKER_ID} from '@dev-landing/constants';

import {EVENTS} from '@dev-landing/analytics/events';

import {logTmrEvent} from '../analytics';

export const useRustoreAppears = (language: string) => {
  const logRustoreAppears = () => {
    const params = {
      isResident: +(language === 'ru'),
    };

    setTimeout(() => {
      logTmrEvent({
        trackerId: DEV_COUNTER_MY_TRACKER_ID,
        logEvent: EVENTS.RUSTORE_APPEARS,
        params,
      });
      logTmrEvent({
        logEvent: EVENTS.devLandingView,
        params: {
          vk_id: '-1',
        },
      });
    });
  };

  return {logRustoreAppears};
};
